import { string } from "yup";
import { countries, type Specification } from "iban";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";
import { normalizeIban } from "@utils/formatting";

/** Null when valid, otherwise a message naming the cause, so the user knows what to fix. */
export const getIbanError = (value: string): string | null => {
  const iban = normalizeIban(value);
  const countryCode = iban.slice(0, 2);
  const specification: Specification | undefined = countries[countryCode];
  // A partial prefix ("FR", "FR7") is let through so that it reads as incomplete rather than malformed.
  if (!/^[A-Z]{2}\d{0,2}$/.test(iban.slice(0, 4))) return "L'IBAN doit commencer par le code pays suivi de 2 chiffres (ex. FR76…)";
  if (!specification) return `Code pays « ${countryCode} » non reconnu`;
  if (iban.length < specification.length)
    return `IBAN incomplet : un IBAN ${countryCode} compte ${specification.length} caractères, vous en avez ${iban.length}`;
  if (iban.length > specification.length)
    return `IBAN trop long : un IBAN ${countryCode} compte ${specification.length} caractères, vous en avez ${iban.length}`;
  if (!specification.isValidBBAN(iban.slice(4))) return `Format incorrect pour un IBAN ${countryCode}, vérifiez les caractères saisis`;
  if (!specification.isValid(iban)) return "Cet IBAN contient une erreur de saisie : comparez-le caractère par caractère avec votre RIB";
  return null;
};

export const ibanValidation = () =>
  string()
    .required(REQUIRED_FIELD)
    .test("iban", function (value) {
      const error = value ? getIbanError(value) : null;
      return error ? this.createError({ message: error }) : true;
    });
